<template>
	<div>
		<div class="mt-3">
			<div class="d-flex flex-wrap">
				<v-col cols="12" class="px-0">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showModalCari">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</div>
			<div class="d-flex flex-wrap mr-n3">
				<template v-if="loading">
					<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="i in 5" :key="i">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100 w-100 custom-skeleton">
							<v-skeleton-loader width="100%" height="140px" type="image" class="rounded-xl"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-5"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="heading" class="mt-3 rounded-xl"></v-skeleton-loader>
						</v-card>
					</v-col>
				</template>
				<template v-else>
					<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="stockist in stockistList" :key="stockist.stockist_member_id">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100">
							<div class="btn-detail" v-if="false">
								<v-btn depressed x-small fab class="amber lighten-3">
									<v-icon color="grey darken-3">mdi-information-variant</v-icon>
								</v-btn>
							</div>
							<div class="rounded-xl overflow-hidden">
								<v-img eager height="140px" :src="stockist.stockist_image ? stockist.stockist_image : require('/public/assets/image/user-pict.jpg')"></v-img>
							</div>
							<div class="py-3">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<div class="font-size-10 product-name secondary--text" v-bind="attrs" v-on="on">{{ stockist.stockist_name }}</div>
									</template>
									<span>{{ stockist.stockist_name }}</span>
								</v-tooltip>
								<div class="font-size-10 font-weight-bold cl-primary">{{ stockist.stockist_code }}</div>
								<div class="pt-2 font-size-10 cl-grey">{{ stockist.stockist_city_name }}</div>
								<div class="pt-1 font-size-9 cl-grey">{{ stockist.stockist_province_name }}</div>
							</div>
							<v-btn block depressed color="primary" class="rounded-xl font-weight-bold text-capitalize" @click="nextStep(stockist)">Pilih</v-btn>
						</v-card>
					</v-col>
					
					<v-col cols="12" class="pl-0 pb-0 text-center" v-if="stockistPagination.next > 1">
						<v-btn depressed height="40" color="amber lighten-4" class="mt-3 grey--text text--darken-2 rounded-xl" :loading="btnLoading" @click="getLoadData">
							<v-icon>mdi-autorenew</v-icon>
							<span class="pl-2 text-capitalize font-weight-bold">Muat Lebih Banyak</span>
						</v-btn>
					</v-col>
				</template>
			</div>
			<div class="mt-3" v-if="stockistList.length == 0 && !loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
							<NoData></NoData>
							<div class="px-3 pt-3 text-center secondary--text">Tidak ada data stokis yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari.vue'

export default {
	components: {
		ModalCari,
	},
	data() {
		return {
			loading: false,
			btnLoading: false,
			page: 1,
			limit: '12',
		}
	},
	computed: {
		...mapState('transaksiProduk', ['stockistList', 'stockistPagination']),
	},
	methods: {
		...mapActions('transaksiProduk', ['getStockistList', 'getLoadStockistList']),

		getData() {
			this.loading = true
			this.getStockistList(this.queryString({sort: 'stockist_member_id', dir: 'ASC', limit:this.limit, page: this.page})).then(() => {
				this.loading = false
			})
		},
		getLoadData() {
			this.loading = true
			this.page += 1
			this.getLoadStockistList(this.queryString({sort: 'stockist_member_id', dir: 'ASC', limit:this.limit, page: this.page})).then(() => {
				this.loading = false
			})
		},
		showModalCari() {
			this.$refs.modalCari.modalShow()
		},
		reset() {
			this.params = []
			this.page = 1
			this.$refs.modalCari.reset()
      this.getData()
		},
		cari(data) {
      this.loading = true
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)
			if(data.code.value)
				this.params.push(data.code)
			if(data.province.value)
				this.params.push(data.province)
			if(data.city.value)
				this.params.push(data.city)
			this.getStockistList(this.queryString({sort: 'stockist_member_id', dir: 'ASC',limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalCari.modalHide()
			})
      this.loading = false
		},
    nextStep(stockist) {
      this.$emit('action', stockist)
    },
	},
	created() {
		this.getData()
	},
};
</script>